import {createApp} from 'vue'
import Store from 'store'
import MobileMenuDrawer from './MobileMenuDrawer'

const component = createApp(MobileMenuDrawer).use(Store)

const el = 'nlx-component--mobile-menu-drawer'

const componentElement = document.createElement('div')
componentElement.classList.add(el,'nlx-mobile-menu-drawer')
document.body.prepend(componentElement)

const DOM = componentElement

if(DOM){
    component.mount('.'+el)
}

